import React from 'react';
import { Box, Modal } from '@mui/material';
import { toast } from 'react-toastify';
import { BoxModal } from 'js/components/Clubs/Segmentation/segmentStyles';

import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import EditUserModalForm from './EditUserModalForm/index.jsx';

/*
  <RegisterUserModalForm
    formFields={clubForms.formFields}
    clubForms={clubForms}
    clubInfo={clubInfo}
    formNotFound={formNotFound}
  />
*/

const EditUserModal = (props) => {
  const { open, setOpen, partnerForms, uId, list } = props;

  const userData = list.find((user) => user.uId.value === uId);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Modal open={open}>
      <BoxModal sx={{ position: 'relative' }}>
        <Box
          sx={{ position: 'absolute', top: '15px', right: '15px', cursor: 'pointer' }}
          onClick={handleClose}
        >
          <CloseRoundedIcon fontSize="large" />
        </Box>
        <h2>Editar Usuário</h2>
        <EditUserModalForm
          userData={userData}
          formFields={partnerForms.formFields}
          clubForms={partnerForms}
          handleClose={handleClose}
        />
      </BoxModal>
    </Modal>
  );
};

export default EditUserModal;
